var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("AttributeEditorDialog", {
        attrs: { viewModel: _vm.attributeEditorDialog },
        on: {
          "attribute-created": _vm.attributeCreated,
          "attribute-updated": _vm.attributeUpdated,
        },
      }),
      _vm._v(" "),
      _c("AttributeDeleterDialog", {
        attrs: { viewModel: _vm.attrDeleterDialog },
        on: {
          "delete-attribute": _vm.handleDeleteAttributeCommand,
          "show-dependencies": _vm.showAttributeDependenciesViewer,
        },
      }),
      _vm._v(" "),
      _c("AttributeDependenciesDialog", {
        attrs: { viewModel: _vm.attrDependenciesDialog },
      }),
      _vm._v(" "),
      _c("AttributesSectionEditor", {
        attrs: { viewModel: _vm.attributesSectionEditor },
        on: { "update-section-name": _vm.handleRenameAttributesSectionCommand },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: { role: "button" },
                        on: { click: _vm.toggleExpandAll },
                      },
                      [_vm._v("Collapse / Expand all")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: { role: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.showAttributeCreator()
                          },
                        },
                      },
                      [_vm._v("Create attribute")]
                    ),
                    _vm._v(" "),
                    _vm._m(1),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-4 offset-lg-8" }, [
                  _c("div", { staticClass: "input-group input-group-lg" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchPhrase,
                          expression: "searchPhrase",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "search",
                        placeholder: "Search for an attribute",
                      },
                      domProps: { value: _vm.searchPhrase },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.searchPhrase = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(2),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.sectionsView, function (s) {
                return _c("div", { staticStyle: { "margin-top": "50px" } }, [
                  _c("div", [
                    _c(
                      "h4",
                      {
                        staticClass: "pull-left",
                        staticStyle: { margin: "0", padding: "0" },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "text-dark",
                            on: {
                              click: function ($event) {
                                s.Expanded = !s.Expanded
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa",
                              class: {
                                "fa-angle-right": !s.Expanded,
                                "fa-angle-down": s.Expanded,
                              },
                            }),
                            _vm._v(" "),
                            s.Name
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: { color: "black !important" },
                                  },
                                  [_vm._v(_vm._s(s.Name))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !s.Name
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "black !important",
                                      "font-style": "italic",
                                    },
                                  },
                                  [_vm._v("Unnamed")]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pull-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-dark",
                          on: {
                            click: function ($event) {
                              return _vm.showAttributesSectionEditor(s)
                            },
                          },
                        },
                        [_vm._v("Edit section name")]
                      ),
                      _vm._v(" | "),
                      _c(
                        "a",
                        {
                          staticClass: "text-dark",
                          on: {
                            click: function ($event) {
                              return _vm.showAttributeCreator(s.Name)
                            },
                          },
                        },
                        [_vm._v("Create attribute")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                  ]),
                  _vm._v(" "),
                  s.Expanded
                    ? _c("div", [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "20px",
                                "overflow-y": "visible",
                              },
                            },
                            [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-bordered table-hover table-browser",
                                  staticStyle: {
                                    "margin-bottom": "0 !important",
                                  },
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "sortable",
                                          class: {
                                            selected: s.OrderBy === "name",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return s.orderByName()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-uppercase font-weight-normal",
                                            },
                                            [_vm._v("Name")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "fa-stack" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-sort-asc fa-stack-1x",
                                                class: {
                                                  selected:
                                                    s.OrderBy === "name" &&
                                                    s.OrderByDescending ===
                                                      false,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-sort-desc fa-stack-1x",
                                                class: {
                                                  selected:
                                                    s.OrderBy === "name" &&
                                                    s.OrderByDescending ===
                                                      true,
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "sortable text-center",
                                          class: {
                                            selected: s.OrderBy === "modified",
                                          },
                                          staticStyle: { width: "180px" },
                                          on: {
                                            click: function ($event) {
                                              return s.orderByModified()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-uppercase font-weight-normal",
                                            },
                                            [_vm._v("Updated on")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "fa-stack" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-sort-asc fa-stack-1x",
                                                class: {
                                                  selected:
                                                    s.OrderBy === "modified" &&
                                                    s.OrderByDescending ===
                                                      false,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-sort-desc fa-stack-1x",
                                                class: {
                                                  selected:
                                                    s.OrderBy === "modified" &&
                                                    s.OrderByDescending ===
                                                      true,
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("th", {
                                        staticStyle: { width: "120px" },
                                      }),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(s.AttributesView, function (attr) {
                                      return _c(
                                        "tr",
                                        {
                                          key: attr.Id,
                                          class: {
                                            "bg-danger": attr.IsSystem,
                                            "table-warning": attr.IsCorporate,
                                          },
                                        },
                                        [
                                          _c("td", [
                                            _c(
                                              "h5",
                                              [
                                                !attr.IsCorporate
                                                  ? [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "text-dark",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.showAttributeEditor(
                                                                attr
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(attr.Name)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-muted",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(attr.Name)
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                _vm._v(" "),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c("small", [
                                                  _vm._v(
                                                    _vm._s(
                                                      attr.InputTypeDisplayName
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              2
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getModifiedDateStr(attr)
                                                  )
                                                ),
                                              ]),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getModifiedTimeStr(attr)
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            [
                                              attr.IsCorporate
                                                ? [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-outline-secondary",
                                                        attrs: {
                                                          type: "button",
                                                          disabled: "",
                                                          "aria-disabled":
                                                            "true",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                Enterprise\n                                            "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "dropdown",
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-outline-secondary dropdown-toggle",
                                                            attrs: {
                                                              type: "button",
                                                              "data-toggle":
                                                                "dropdown",
                                                              "aria-haspopup":
                                                                "true",
                                                              "aria-expanded":
                                                                "false",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                    Actions\n                                                "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "dropdown-menu dropdown-menu-right",
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showAttributeEditor(
                                                                        attr
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Edit attribute"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showAttributeCloner(
                                                                        attr
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Clone attribute"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("div", {
                                                              staticClass:
                                                                "dropdown-divider",
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showAttributeDependenciesViewer(
                                                                        attr.Id
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "View dependencies"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("div", {
                                                              staticClass:
                                                                "dropdown-divider",
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showAttributeDeleter(
                                                                        attr.Id
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Delete attribute"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6 d-flex align-items-center" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Attributes")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-outline-secondary btn-lg",
        attrs: {
          href: "https://www.transparentchoice.com/user-guide/attributes",
          title: "User guide: Configure attributes",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-info", attrs: { "aria-hidden": "true" } })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }